// EL TAMAÑO DE LOS TRES NÚMEROS GRANDES DEL DÍA (Inicio y Nutrición), en un solo sitio.
//
// Francisco, 26-09, en un Android estrecho: «los números de los macros son muy grandes, se
// juntan y no se sabe cuál es cada uno; pensaba que eran 9.000 de hidratos» («192,9178,459,3»).
// A 44 px, «192,9» mide unos 130 px y la columna de un móvil de 360 no llega a 100. Inicio ya
// bajaba a 36 px los de cinco caracteres o más (27-08), pero con un tamaño fijo, y Nutrición
// ni eso. Ahora crecen con el ancho de la pantalla y tienen techo: 36 px los largos y 44 px los
// cortos; desde `sm` (la columna pasa de 170 px) los 44 de siempre.
export const tamanoDelNumero = (escrito) => (String(escrito || '').length >= 5
    ? 'text-[clamp(24px,9vw,36px)] sm:text-[44px]'
    : 'text-[clamp(30px,11.5vw,44px)] sm:text-[44px]');
